import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Image, LI, P, UL } from "../../../AbstractElements";
import { Admin, HelenWalter } from "../../../Constant";
import { PROFILE } from "../../../Data/Header/Profile";

const Profile = () => {
  const logoutHandler = (title: string) => {
    if (title === "Log out") {
      localStorage.clear();
    }
  };
  
  return (
    <Fragment>
      <div className="d-flex profile-media">
        <Image src={`${process.env.PUBLIC_URL}/assets/images/profile.png`} alt="" />
        <div className="flex-grow-1">
          <span>{HelenWalter}</span>
          <P className="mb-0 font-roboto">
            {Admin} <i className="fa fa-angle-down"></i>
          </P>
        </div>
      </div>
      <UL className="profile-dropdown onhover-show-div">
        {PROFILE.map((item, index) => (
          <LI key={index} onClick={() => logoutHandler(item.title)}>
            <Link to={item.url}>
              {item.icon}
              <span>{item.title} </span>
            </Link>
          </LI>
        ))}
      </UL>
    </Fragment>
  );
};

export default Profile;
